import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BookingService } from '@app/listing/services/booking.service';
import { PermitService } from '@app/listing/services/permit.service';
import { SeasonalRentalService } from '@app/listing/services/seasonal-rental.service';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { ToastrModule } from 'ngx-toastr';

import { ActivityService } from './activity.service';
import { AdminSearchService } from './admin-search.service';
import { ArrayService } from './array.service';
import { AttachmentService } from './attachment.service';
import { AvailabilityService } from './availability.service';
import { BackgroundCheckService } from './background-check.service';
import { CacheService } from './cache.service';
import { CardService } from './card.service';
import { CircleService } from './circle.service';
import { ClientStorageService } from './client-storage.service';
import { CoatCheckService } from './coat-check.service';
import { ContactUsService } from './contact-us.service';
import { ContentService } from './content.service';
import { CreditService } from './credit.service';
import { DataModelService } from './data-model.service';
import { ElementHelperService } from './element-helper.service';
import { ErrorHelperService } from './error-helper.service';
import { ExtendedLeaseDiscountService } from './extended-lease-discount.service';
import { FavoritesService } from './favorites.service';
import { FeeService } from './fee.service';
import { FileDownloadService, DateService, LogService, ListingService, UserService, ValueService, AppSettingsService, ListingCacheService, DeviceService, MembershipService, NotificationService, StripeService } from '@oa/shared-core';
import { FormsService } from './forms.service';
import { GeoHashService } from './geo-hash.service';
import { GeometryService } from './geometry.service';
import { HelpService } from './help.service';
import { LexiconService } from './lexicon.service';
import { ListingContactService } from './listing-contact.service';
import { QueryFilterService } from './listing-query-filter.service';
import { ListingSearchService } from './listing-search.service';
import { MapConfigurationService } from './map-configuration.service';
import { MapLocationService } from './map-location.service';
import { MessageService } from './message.service';
import { NavigationService } from './navigation.service';
import { OpenLayerMapService } from './open-layer-map.service';
import { OpenLayerStyleService } from './open-layer-style.service';
import { PaymentService } from './payment.service';
import { PermitInstanceService } from './permit-instance.service';
import { ReferralEmailService } from './referral-email.service';
import { ReservationService } from './reservation.service';
import { ReviewService } from './review.service';
import { ScriptLoaderService } from './script-loader.service';
import { SeasonsService } from './seasons.service';
import { SocialMediaContentService } from './social-media-content.service';
import { SpinnerService } from './spinner.service';
import { SystemService } from './system.service';
import { ValidationService } from './validation.service';
import { WorkTaskService } from './work-task.service';
import { WorkflowService } from './workflow.service';
import { PaymentEventService } from './payment-event.service';
import { AOIService } from './aoi.service';
import { RouteHelperService } from './route-helper.service';
import { StickyService } from './sticky.service';
import { ScoutingBookingService } from '@app/listing/services/scouting-booking.service';
import { ExitIntentService } from './exit-intent.service';
import { FieldDataCollectionService } from './field-data-collection.service';
import { ExternalOrgService } from './external-org.service';
import { AdministrativeBoundaryService } from './administrative-boundary.service';
import { ParcelService } from './parcel.service';
import { MetadataService } from './metadata.service';
import { SpatialService } from './spatial.service';
import { EntityService } from './entity.service';
import { TemplateService } from './template.service';
import { SiteVisitService } from './site-visit.service';
import { AppRouteChangeService } from './app-route-change.service';
import { UserProfileService } from './user-profile.service';
import { IconLinkService } from './icon-link.service';
import { IconService } from './icon.service';
 




// import { Http, RequestOptions, XHRBackend } from '@angular/http';
 
 



// export function httpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions, clientStorage: ClientStorageService) {
//   return new AuthHttp(xhrBackend, requestOptions, clientStorage);
// }

@NgModule({ declarations: [], imports: [CommonModule,
        NgxPageScrollModule,
        BrowserAnimationsModule, // required animations module
        ToastrModule.forRoot() // ToastrModule added
    ], providers: [
        ClientStorageService,
        // {
        //   provide: Http,
        //   useFactory: httpFactory,
        //   deps: [XHRBackend, RequestOptions, ClientStorageService]
        // },
        ContentService,
        ListingSearchService,
        ActivityService,
        AvailabilityService,
        ReviewService,
        ReservationService,
        AttachmentService,
        CircleService,
        HelpService,
        PaymentService,
        MembershipService,
        NavigationService,
        BackgroundCheckService,
        NotificationService,
        StripeService,
        FeeService,
        ScriptLoaderService,
        SeasonsService,
        ContactUsService,
        ListingContactService,
        CreditService,
        CardService,
        AdminSearchService,
        SocialMediaContentService,
        FavoritesService,
        WorkTaskService,
        QueryFilterService,
        PermitInstanceService,
        PermitService,
        BookingService,
        SeasonalRentalService,
        WorkflowService,
        ElementHelperService,
        SpinnerService,
        ValidationService,
        FormsService,
        OpenLayerStyleService,
        OpenLayerMapService,
        GeometryService,
        GeoHashService,
        CoatCheckService,
        ArrayService,
        LexiconService,
        MapLocationService,
        ExtendedLeaseDiscountService,
        DataModelService,
        ReferralEmailService,
        MapConfigurationService,
        MessageService,
        FileDownloadService,
        DeviceService,
        ErrorHelperService,
        SystemService,
        CacheService,
        PaymentEventService,
        AOIService,
        RouteHelperService,
        StickyService,
        ScoutingBookingService,
        ExitIntentService,
        FieldDataCollectionService,
        ExternalOrgService,
        AdministrativeBoundaryService,
        ParcelService,
        MetadataService,
        SpatialService,
        EntityService,
        TemplateService,
        SiteVisitService,
        AppRouteChangeService,
        UserProfileService,
        IconLinkService,
        IconService,
        DateService,
        ListingService,
        AppSettingsService,
        UserService,
        LogService,
        ValueService,
        ListingCacheService,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class ServicesModule { }
